<template>
  <div class="presence-for-users text-dark">
    <div class="d-table-layout">
      <div class="d-table-layout__col">
        <div class="d-table-layout__header">
          <h3>{{ i18n[locale]['add_presence_to_many_user'] }}</h3>
          <div class="d-table-layout__header__right">
            <p>{{ selectedIdsLength }} {{ i18n[locale]['of'] }} {{ usersFiltered.length }}</p>
            <div v-if="selectedIdsLength < 1" class="hint--bottom-left"
                 :aria-label="$t('vue2.tagging.select_persons_first')">
              <button class="up__button no-print bttn bttn--disabled">
                {{ $t('vue2.presence.work_hours') }}
                <span class="icon-arrow-down5"></span>
              </button>
            </div>
            <PresenceUser
              v-else
              :firstDayOfWeek="firstDayOfWeek"
              @save="savePresence"></PresenceUser>
          </div>

        </div>
        <div class="d-table-layout__header">
          <div>
            <p v-if="selectedIdsLength < 1" class="text-link" @click="selectAll">{{
                $t('vue2.tagging.select_all')
              }}</p>
            <p v-else @click="unSelectAll" class="text-link">{{ $t('vue2.tagging.unselect_all') }}</p>
          </div>
          <TaggingFilter
            :users="usersWithProps"
            :showHowMany="false"
            :tags="tags"
            :selectedTags="selectedTags"
            :schoolid="schoolId"
            @set="setTag"
            @remove="removeTag">
          </TaggingFilter>
        </div>
        <div class="d-table-layout__body">
          <Loader v-if="isLoadingSchoolCalenders" bgColor="#fff"></Loader>
          <template v-else>
            <p class="text-explainer" v-if="usersWithProps.length < 1">{{ i18n[locale]['no_users_created'] }}</p>
            <ul class="presence__user-list">
              <li v-for="user in usersWithProps" :key="user.id" @click="toggleUser(user.id)"
                  :class="{'user--selected': user.v_isSelected}">
                <div class="d-checkbox" :class="{'d-checkbox--active': user.v_isSelected}"></div>
                <p>{{ user.name }}</p>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PresenceUser from './User/PresenceUser'
import TaggingFilter from '../Tagging/TaggingFilter'
import docendo from '../../docendo'
import Loader from '../common/Loader'
import eventbus from '../../eventbus'
import DModal from '../common/DModal'

export default {
  components: {
    DModal,
    Loader,
    TaggingFilter,
    PresenceUser
  },
  data () {
    return {
      selectedIds: {},
      selectedTags: [],
      tags: [],
      i18n: {
        da: {
          add_presence_to_many_user: 'Tildel arbejdstider til flere brugere',
          of: 'af',
          no_users_created: 'Ingen brugere oprettet'
        },
        en: {
          add_presence_to_many_user: 'Add working hours to multiple users',
          of: 'of',
          no_users_created: 'No users created'
        },
        nb: {
          add_presence_to_many_user: 'Legg inn arbeidstider for flere brukere',
          of: 'av',
          no_users_created: 'Ingen brukere opprettet'
        }
      }
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    locale () {
      return this.$store.getters.locale
    },
    firstDayOfWeek () {
      return this.$store.getters.firstDayOfWeek
    },
    selectedIdsLength () {
      return Object.keys(this.selectedIds).length
    },
    users () {
      return this.$store.getters.userCalendars
    },
    usersFiltered () {
      if (this.selectedTags.length === 0) {
        return this.users
      }
      return this.users.filter(user => {
        return this.selectedTags.some(tag => user.user_tags.includes(tag))
      })
    },
    usersWithProps () {
      return this.usersFiltered.map(user => {
        this.$set(user, 'v_isSelected', this.isUserSelected(user.id))
        return user
      })
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    }
  },
  methods: {
    isUserSelected (userId) {
      return this.selectedIds[userId]
    },
    toggleUser (userId) {
      if (this.isUserSelected(userId)) {
        this.$delete(this.selectedIds, userId)
      } else {
        this.$set(this.selectedIds, userId, true)
      }
    },
    selectAll () {
      this.usersWithProps.forEach(user => {
        this.$set(this.selectedIds, user.id, true)
      })
    },
    unSelectAll () {
      this.usersWithProps.forEach(user => {
        this.$delete(this.selectedIds, user.id)
      })
    },
    getTags () {
      docendo.schoolTags(this.schoolId, data => {
        this.tags = data
      })
    },
    setTag (tag) {
      this.unSelectAll()
      this.selectedTags.push(tag)
    },
    removeTag (tag) {
      this.unSelectAll()
      this.selectedTags.splice(this.selectedTags.indexOf(tag), 1)
    },
    savePresence (emitData) {
      eventbus.toast = {text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false}
      emitData.calendarIds = Object.keys(this.selectedIds)
      console.log('emitData.eventsToCreate', emitData.eventsToCreate)
      docendo.createPresenceForMany(this.schoolId, emitData.calendarIds, emitData.pasteInWeeks, emitData.eventsToCreate, success => {
        console.log('success', success)
      }, failure => {
        console.log('failure', failure)
      })
      this.unSelectAll()
    },
    close () {
      this.$emit('close')
    }
  },
  mounted () {
    this.getTags()
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.presence-for-users .d-modal__header {
  margin-bottom: 0;
  border-bottom: 0;
}

.presence-for-users {
  width: 100%
}

.d-table-layout {
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 7%);
  background: #fff;
}

.d-table-layout__col {
  border: 1px solid #d8d8d8;
  border-width: 1px 0 1px 1px;
  flex: 1;
}

.d-table-layout__header {
  padding: 1rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #1a1f36;
  height: 55px;
  justify-content: space-between;
}

.d-table-layout__header h4 {
  color: #728195;
}

.d-table-layout__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-table-layout__body ul {
  width: 100%;
}

.d-table-layout__body ul li {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.25s;
  border-top: 1px solid transparent;
}

.d-table-layout__body ul li:hover {
  background-color: #f6f9fc;
}

.d-table-layout__body ul li.li--active {
  background: aliceblue;
}

.d-table-layout__body ul li p {
  margin-left: 1rem;
}

.text-link {
  color: var(--blue);
  font-weight: bold;
  font-size: 11px;
  cursor: pointer;
  text-decoration: none !important;
  user-select: none;
}

.text-link:hover {
  color: var(--dark-blue)
}

.user--selected {
  border-top: 1px solid #fff;
  background-color: rgba(77, 138, 207, .1);
}

.d-table-layout__header__right {
  display: flex;
  align-items: center;
}

.d-table-layout__header__right > p {
  margin-right: 1rem;
  font-style: italic;
  font-size: 11px;
}

</style>



// WEBPACK FOOTER //
// PresenceForUsers.vue?136535a9